import { render, staticRenderFns } from "./TLabeledValue.vue?vue&type=template&id=b2494ff8&scoped=true&"
import script from "./TLabeledValue.vue?vue&type=script&lang=js&"
export * from "./TLabeledValue.vue?vue&type=script&lang=js&"
import style0 from "./TLabeledValue.vue?vue&type=style&index=0&id=b2494ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2494ff8",
  null
  
)

/* custom blocks */
import block0 from "./TLabeledValue.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports